import { action } from 'easy-peasy';
import { IActionDeletePatientNotificationRule } from '../types';

const deletePatientNotificationRule: IActionDeletePatientNotificationRule = action((state, id) => {
  state.items = state.items.filter(item => item.id !== id);
});

export default deletePatientNotificationRule;
